import dayjs from 'dayjs';

const apiDateFormat = 'YYYY-MM-DD';

export const formatDate = (date, format = apiDateFormat) => {
  if (date === null || date === '') {
    return '';
  }

  return dayjs(date).format(format);
};

export const parseDate = (dateString, format = apiDateFormat) => {
  if (dateString === '') {
    return null;
  }

  return dayjs(dateString, format).toDate();
};

export const isDateinYearBounds = (date, yearMin, yearMax) =>
  date?.getFullYear() >= yearMin && date?.getFullYear() <= yearMax;

export const dateFormat = 'DD-MM-YYYYTHH:mm:ss';

// an empty string act as the earlier/oldest date possible
const getDateBound = (date, dateBound) => (date === '' ? dateBound : date);

/**
 * Find the min or max year when dealing with 2 date ranges
 * We need to get the earliest/latest dates from 2 date values
 * taking into account that empyt string mean the earliest/latest date available
 * @param {string} firstDateValue 'YYYY-MM-DD'
 * @param {string} secondDateValue 'YYYY-MM-DD'
 * @param {string} dateBound 'YYYY-MM-DD'
 * @param {string} type min / max
 * @returns {int}
 */
export const getMinOrMaxYear = (firstDateValue, secondDateValue, dateBound, type = 'min') => {
  const firstDate = getDateBound(firstDateValue, dateBound);
  const secondDate = getDateBound(secondDateValue, dateBound);

  let minOrMaxDate = '';
  if (type === 'min') {
    minOrMaxDate = firstDate <= secondDate ? firstDate : secondDate;
  }
  if (type === 'max') {
    minOrMaxDate = firstDate >= secondDate ? firstDate : secondDate;
  }

  return minOrMaxDate ? parseDate(minOrMaxDate).getFullYear() : '';
};
